export type MeasurementUnitStatusDto =
  | string
  | {
      code?: string;
      name?: string;
      label?: string;
      value?: string;
      tone?: string;
    };

export type MeasurementUnitDto = {
  uuid: string;
  name: string;
  description: string | null;
  status: MeasurementUnitStatusDto;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type MeasurementUnitRequest = {
  name: string;
  description: string | null;
};

export type MeasurementUnitListQuery = {
  name?: string;
  description?: string;
  status?: string[];
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
};

export type MeasurementUnitListResult = {
  items: MeasurementUnitDto[];
  total: number;
};

export type MeasurementUnitFilterOption = {
  name: string;
  value: string;
};

export type MeasurementUnitFilterSelects = {
  status: MeasurementUnitFilterOption[];
};

export type MeasurementUnitStatusLabel = 'Activo' | 'Inactivo';

export function measurementUnitStatusLabel(
  dto: MeasurementUnitDto,
): MeasurementUnitStatusLabel {
  const status = dto.status;
  if (status && typeof status === 'object') {
    if (status.tone === 'danger') return 'Inactivo';
    if (status.tone === 'success') return 'Activo';
    return classifyStatusName(status.name ?? status.label ?? status.code ?? '');
  }
  if (typeof status === 'string') {
    return classifyStatusName(status);
  }
  if (typeof dto.enabled === 'boolean') {
    return dto.enabled ? 'Activo' : 'Inactivo';
  }
  return 'Activo';
}

function classifyStatusName(raw: string): MeasurementUnitStatusLabel {
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === 'inactivo' ||
    normalized === 'inactiva' ||
    normalized === 'inactive' ||
    normalized === 'disabled' ||
    normalized.startsWith('inactiv')
  ) {
    return 'Inactivo';
  }
  return 'Activo';
}
